module.exports = __webpack_public_path__ + "static/media/IMG_0860.fe057da0.JPG";